import React from "react";
import styled from "styled-components";

import { ModalService } from "../../../../service/modal-service";
import ToastService from "../../../../service/toast-service";
import { Row, Box, Col, Text, HGap, Button, InputBox } from "../../../../comps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../../theme/theme-provider";

import { faCopy } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.BLUE_4};
`;

const InputWrapper = styled(Box)`
  width: 80%;
  height: 30px;
  margin-top: 20px;
`;

const ButtonWrapper = styled(Box)`
  margin-top: 18px;
`;

export default ({ roomId }) => {
  const manualCopy = () => {
    window.prompt("Copy to clipboard: Ctrl+C, Enter", roomId);
  };

  const success = () => {
    ToastService.infoToast("Room Id copied to clipboard");
    ModalService.closeModal();
  };

  const fallbackCopyTextToClipboard = () => {
    var textArea = document.createElement("textarea");
    textArea.value = roomId;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) success();
      else manualCopy();
    } catch (err) {
      manualCopy();
    }
    document.body.removeChild(textArea);
  };
  const handleCopy = () => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(roomId);
      return;
    }
    navigator.clipboard.writeText(roomId).then(success, manualCopy);
  };

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >{`Share the room id to invite`}</Text>
      </Head>
      <InputWrapper>
        <InputBox
          fontSize="14px"
          background={Theme.color.GRAY_3}
          readOnly={true}
          defaultValue={roomId}
        />
      </InputWrapper>
      <ButtonWrapper>
        <Button
          buttonTextColor={Theme.textColor.light}
          borderRadius="50"
          buttonBackground={Theme.color.BLUE_4}
          buttonName="Copy"
          buttonIcon={faCopy}
          buttonFontSize="14px"
          size="small"
          onClick={handleCopy}
        />
      </ButtonWrapper>
    </Wrapper>
  );
};
